module.exports = __webpack_public_path__ + "fonts/HachiMaruPop-Regular.bc06cd64.ttf";